const DefaultAddress = ({ address, addressCount }) => {
  if (address.isDefault && addressCount > 1) {
    return (
      <>
        <br />
        <em>(Default for Website)</em>
      </>
    );
  }
  return null;
};

export default DefaultAddress;
